import type { TFunction } from 'i18next'

export const labManagementTableProps = {
  tableFixedWidth: true,
  tableMinWidth: 1000
} as const

export const labManagementNameCellStyle = {
  whiteSpace: 'normal',
  wordBreak: 'break-word'
} as const

export const getLabManagementHeadCells = (t: TFunction, nameColumnId: string, nameLabelKey: string, statusLabelKey: string, updatedByLabelKey: string) => [
  { id: 'no', disablePadding: false, label: '#', width: '5%' },
  { id: nameColumnId, disablePadding: false, label: t(nameLabelKey), width: '55%' },
  { id: 'status', disablePadding: false, label: t(statusLabelKey), width: '12%' },
  { id: 'updatedBy', disablePadding: false, label: t(updatedByLabelKey), width: '16%' },
  { id: 'action', disablePadding: false, label: 'Action', width: '12%' }
]
